<div class="cv-studio-pane-header">
  <input type="text"
         class="cv-studio-pane-title-input"
         [formControl]="$any(form.controls.name)"
         maxlength="80"
         aria-label="Template name" />
  @if (savedAt) {
    <span class="cv-studio-pane-saved-inline">{{ 'cv_studio.saved_indicator' | translate }}</span>
  }
  <button nbButton ghost status="danger" size="small"
          class="cv-studio-pane-header-delete"
          (click)="confirmDelete()"
          [nbTooltip]="'cv_studio.delete_template_link' | translate">
    <nb-icon icon="trash-2-outline"></nb-icon>
  </button>
</div>
<p class="cv-studio-pane-description">
  <span class="cv-studio-pane-base-layout">
    <label for="cv-studio-base-layout">{{ 'cv_studio.custom_built_on_label' | translate }}</label>
    <nb-select id="cv-studio-base-layout"
               size="small"
               [formControl]="$any(form.controls.base_layout_id)">
      @for (layout of baseLayouts; track layout.id) {
        <nb-option [value]="layout.id">{{ layout.name }}</nb-option>
      }
    </nb-select>
  </span>
  <span class="cv-studio-pane-meta-sep">·</span>
  <span class="cv-studio-pill cv-studio-pill-status cv-studio-pill-status-{{ template.status }}">
    {{ 'cv_templates.status.' + template.status | translate }}
  </span>
</p>

<div class="cv-studio-pane-thumb"
     [nbSpinner]="template.status === 'processing'"
     nbSpinnerStatus="primary"
     nbSpinnerSize="large">
  @if (template.status === 'processing') {
    <div class="cv-studio-pane-thumb-placeholder cv-studio-pane-thumb-processing">
      <strong>{{ 'cv_studio.processing_thumb_title' | translate }}</strong>
      <p>{{ 'cv_studio.processing_thumb_body' | translate }}</p>
    </div>
  } @else if (template.status === 'failed') {
    <div class="cv-studio-pane-thumb-placeholder cv-studio-pane-thumb-failed">
      <strong>{{ 'cv_studio.failed_thumb_title' | translate }}</strong>
      <p>{{ 'cv_studio.failed_thumb_body' | translate }}</p>
    </div>
  } @else if (thumbnailUrl(); as src) {
    <img [src]="src" alt="" />
  } @else {
    <div class="cv-studio-pane-thumb-placeholder">{{ 'cv_studio.no_thumbnail' | translate }}</div>
  }
</div>

<div class="cv-studio-pane-actions">
  <button nbButton status="primary" (click)="openPreview()"
          [disabled]="previewLoading
                      || template.status === 'processing'
                      || template.status === 'failed'">
    @if (previewLoading) {
      <nb-icon icon="loader-outline"></nb-icon>
      {{ 'cv_studio.generating_preview' | translate }}
    } @else {
      {{ 'cv_studio.download_preview_button' | translate }}
    }
  </button>
  <button nbButton outline (click)="requestReplace()"
          [disabled]="template.status === 'processing'">
    {{ 'cv_studio.replace_files_button' | translate }}
  </button>
</div>

<small class="text-danger" *ngIf="fieldErrors['name']">{{ fieldErrors['name'] }}</small>
